<template>

    <main id="content" class="relative w-full pt-20 xl:pt-28 2.5xl:pt-38">

        <section class="relative z-20 flex flex-col items-center w-full h-auto pt-12 pb-16 sm:py-16 lg:py-20 xl:py-12 2xl:py-20">

            <div class="max-w-[calc(100%-3rem)] sm:px-4 md:px-0 sm:max-w-1.5xl xl:max-w-6.5xl 1.5xl:max-w-7xl 2xl:max-w-7xl 2.5xl:max-w-8xl mx-auto w-full">

                <h1 class="text-white text-[40px] sm:text-[45px] md:text-[50px] lg:text-[54px] xl:text-[60px] 2xl:text-[64px] 3xl:text-[67px] 3.5xl:text-[70px] !leading-snug font-light tracking-[0.01em] mx-auto text-center mb-14 md:mb-16 lg:mb-18 xl:mb-20 2xl:mb-22 3xl:mb-24">
                    {{$root.translateString('your_cart')}} ({{ itemCount }})
                </h1>

                <div v-if="isNotEmpty(cart)" class="w-full flex flex-col xl:flex-row space-y-12 xl:space-y-0 xl:space-x-12 2xl:space-x-15 2.5xl:space-x-20">

                    <div class="flex flex-col flex-grow border-t border-white/30">

                        <div v-for="(item, key) in cart" :key="key" class="flex flex-col w-full py-6 space-y-5 border-b sm:flex-row text-secondary-400 border-white/30 sm:space-y-0">

                            <div class="flex items-center xl:flex-grow w-full max-w-[36ch]">
                                <div class="flex items-center justify-center w-16 h-16 p-3 min-w-16 xs:w-20 xs:min-w-20 xs:h-20 md:w-22 md:min-w-22 md:h-22 bg-white/10">
                                    <img width="70" class="object-contain w-full h-full" :src="item.options.image" :alt="item.options.name" />
                                </div>
                                <div class="flex flex-grow pt-0 pl-6">
                                    <span class="flex flex-col flex-grow">
                                        <span class="uppercase text-white !leading-tight text-1.5xl xl:text-2xl block" v-text="item.options.name"></span>
                                        <span class="w-full flex flex-col text-lg -mt-0.5">
                                            <span class="w-full !leading-snug" v-if="item.options.type == 'vini'" v-text="item.options.combination"></span>
                                            <span class="w-full !leading-snug" v-else-if="item.options.type == 'visite'">
                                                {{parseInt(item.options.visit.adults) + parseInt(item.options.visit.kids)}}
                                                <span v-if="item.options.visit.adults==1">{{$root.translateString('person')}}</span>
                                                <span v-else>{{$root.translateString('people')}}</span>
                                                <span v-if="item.options.combination">
                                                    -
                                                {{item.options.combination.replace(" ", "")}}
                                                </span>
                                            </span>
                                            <span class="w-full" v-else>Cantina Letrari</span>
                                        </span>
                                    </span>
                                </div>
                            </div>

                            <div class="flex items-center flex-grow sm:space-x-10">
                                <div class="flex items-center flex-grow space-x-4 sm:justify-center xl:space-x-8">
                                    <div class="inline-flex">
                                        <button @click="decreaseQuantity(key, item)" type="buttton" class="flex items-center justify-center w-10 transition-all border border-white/30 hover:bg-white/10">
                                            <img class="w-[11px] h-auto" src="/images/svg/icon-less.svg" alt="icona" />
                                        </button>

                                        <div class="w-auto h-full pointer-events-none border-y border-white/30">
                                            <input class="w-12 h-8 text-sm text-center text-white bg-transparent border-0" readonly type="number" min="1" v-model="item.qty" />
                                        </div>

                                        <button @click="increaseQuantity(key, item)" type="buttton" class="flex items-center justify-center w-10 transition-all border border-white/30 hover:bg-white/10">
                                            <img class="w-[11px] h-auto" src="/images/svg/icon-add.svg" alt="icona" />
                                        </button>
                                    </div>
                                    <div class="flex items-center">
                                        <span class="flex-grow text-lg text-white whitespace-nowrap">
                                            € {{ $root.currencyDisplaySimple(parseFloat(item.price) * parseInt(item.qty)) }}
                                        </span>
                                    </div>
                                </div>
                                <div class="flex items-center">
                                    <button type="button" class="inline-flex items-center transition-all hover:text-white" href="javascript:void(0)" @click="updateCart(key, 0)">
                                        <img class="w-6 h-6 transition-all hover:opacity-80" src="/images/svg/icon-remove.svg" alt="icona" />
                                    </button>
                                </div>
                            </div>

                        </div>

                    </div>

                    <div class="flex flex-col space-y-8 xl:min-w-[460px]">

                        <div class="p-6 sm:p-10 xl:p-12 text-lg sm:text-xl xl:text-xl 2.5xl:text-1.5xl text-secondary-400 bg-white/5">

                            <div class="flex items-center justify-center w-full px-3 py-2 mb-4 text-center bg-primary-400/20 sm:px-6 sm:py-3">
                                <span class="text-[15px] uppercase text-white !tracking-[0.05em]">{{$root.translateString('free_shipping')}} <span>€110</span></span>
                            </div>

                            <div class="pb-5 mb-3 text-center border-b text-primary-400 border-white/30" v-if="missing_for_free_shipping > 0">
                                <span class="!leading-none block w-full text-center" v-if="lang == 'it'">
                                    Sei a € {{$root.currencyDisplaySimple(missing_for_free_shipping)}} dalla spedizione gratuita.
                                </span>
                                <span class="!leading-none block w-full text-center" v-else>
                                    € {{$root.currencyDisplaySimple(missing_for_free_shipping)}} left for free shipping.
                                </span>
                            </div>

                            <div class="flex pb-2">
                                <div class="flex-grow">{{$root.translateString('subtotal')}}</div>
                                <div class="">
                                    € {{ $root.currencyDisplaySimple(priceTotalWt) }}
                                </div>
                            </div>

                            <div class="flex pb-4 spedizione" v-if="should_be_shipped">
                                <div class="flex-grow">{{$root.translateString('shipping')}}</div>
                                <div class="">
                                    <span v-if="shipping > 0">
                                        € {{ $root.currencyDisplaySimple(shipping) }}
                                    </span>
                                    <span v-else>{{$root.translateString('free')}}</span>
                                </div>
                            </div>

                            <div class="flex pb-4 spedizione" v-if="discount > 0">
                                <div class="flex-grow">{{$root.translateString('discount')}}</div>
                                <div class="">
                                    € {{ $root.currencyDisplaySimple(discount) }}
                                </div>
                            </div>

                            <div class="flex py-3 border-t border-white/30">
                                <div class="flex flex-col flex-grow">
                                    <div class="text-white">{{$root.translateString('total')}}</div>
                                    <small class="-mt-2">{{$root.translateString('tax_included')}}</small>
                                </div>
                                <div class="text-white"> € {{ $root.currencyDisplaySimple(finalPrice) }} </div>
                            </div>

                            <div class="w-full pt-2 mt-3 text-center">
                                <div class="flex w-full">
                                    <a :href="$root.langRoute('/cassa')" class="relative inline-flex border default-btn border-primary-300 group flex-grow w-full text-center xl:max-w-[340px] 2xl:max-w-[386px] hover:bg-primary-400/10 transition-all">
                                        <span class="block w-full pt-2.5 pb-3 px-15 text-primary-300 text-[18px] md:text-[19px] xl:text-[20px]">
                                            {{$root.translateString('complete_checkout')}}
                                        </span>
                                        <span class="absolute top-1/2 -translate-y-1/2 -left-[8px] w-[16px] h-[1px] bg-primary-300 group-hover:left-6 transition-all"></span>
                                        <span class="absolute top-1/2 -translate-y-1/2 -right-[8px] w-[16px] h-[1px] bg-primary-300 group-hover:right-6 transition-all"></span>
                                    </a>
                                </div>
                            </div>

                        </div>

                        <discount-box :lang="lang" :discount="discount"></discount-box>

                    </div>

                </div>

                <div v-else class="relative flex justify-center w-full text-center">

                    <div class="mx-auto">
                        <a :href="'/' + lang + '/wine-club/shop'" class="relative flex items-center group transition-all space-x-3.5">
                            <span class="rounded-full bg-transparent group-hover:bg-white w-[40px] h-[40px] flex justify-center items-center transition-all">
                                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
                                    <g id="Raggruppa_1236" data-name="Raggruppa 1236" transform="translate(-4521.689 -4109.535)">
                                    <circle id="Ellisse_73" data-name="Ellisse 73" cx="20" cy="20" r="20" transform="translate(4521.689 4109.535)" fill="#fff" opacity="0.15"/>
                                    <g id="Raggruppa_1235" data-name="Raggruppa 1235">
                                        <line id="Linea_247" data-name="Linea 247" x1="20.715" transform="translate(4531.332 4129.535)" fill="none" stroke="#9f7f49" stroke-width="1"/>
                                        <path id="Tracciato_1377" data-name="Tracciato 1377" d="M4538.828,4137.023l-7.488-7.488,7.488-7.488" fill="none" stroke="#9f7f49" stroke-width="1"/>
                                    </g>
                                    </g>
                                </svg>
                            </span>
                            <span class="text-primary-300 text-[18px] md:text-[19px] xl:text-[20px] font-light group-hover:text-white transition-all">{{$root.translateString('back-to-wines')}}</span>
                        </a>
                    </div>

                </div>

            </div>

        </section>

    </main>

</template>

<script>

    export default {
        props:['lang'],
        data() {
            return {
                show:false,
                cartRaw: null,
                count: 0,
                shipping: 0,
                discount: 0,
                finalPrice: 0,
                priceTotalWt: 0,
                missing_for_free_shipping: 0,
                should_be_shipped: false,
            }
        },
        mounted() {

            this.getCart();

            this.$eventHub.$on('cart.added', payload => {
                this.getCart();

                this.show = true;

                setTimeout(() => {
                    this.show = false;
                }, 5000);
            });

            this.$eventHub.$on('cart.show', payload => {
                this.show = true;
            });

            this.$eventHub.$on('discount.applied', payload => {
                this.getCart();
            });

        },
        methods: {
            increaseQuantity(key, item) {
                if(item.qty < 30) {
                    item.qty++;
                }else{
                    item.qty = 30;
                }
                this.updateCart(key, item.qty);
            },
            decreaseQuantity(key, item) {
                if(item.qty > 1) {
                    item.qty--;
                }else{
                    item.qty = 1;
                }
                this.updateCart(key, item.qty);
            },
            goToCheckout(url) {
                let temp_cart = [];

                Object.keys(this.cart).forEach((o, k) => {
                    let entry = {};
                    entry.id = this.cart[o].options.name
                    entry.quantity = this.cart[o].qty
                    temp_cart.push(entry);
                });

                /*fbq('track', 'InitiateCheckout',
                    {
                        value: parseFloat(this.priceTotalWt),
                        currency: 'EUR',
                        contents: temp_cart,
                        content_type: 'product_group'
                    }
                );*/

                window.location.href = url;
            },
            emptyCart() {
                axios.post('/api/cart/empty', {})
                .then(response => {
                    this.cartRaw = null;
                    this.shipping = 0;
                    this.priceTotalWt = 0;
                    this.finalPrice = 0;
                    this.discount = 0;
                    this.missing_for_free_shipping = 0;
                    this.should_be_shipped = false;
                })
            },
            updateCart(key, value) {

                axios.post('/api/cart/update', {
                    key: key,
                    qty: value,
                })
                .then(response => {
                    this.getCart();
                    this.$eventHub.$emit('cart.updated');
                    this.$eventHub.$emit('cart.updated.simpleQty', parseInt(response.data.count));

                    let update_type = 'add';
                    let quantity_to_track = value;

                    if(quantity_to_track == 0) {

                        quantity_to_track = this.cart[key].qty;

                        dataLayer.push({ ecommerce: null });
                        dataLayer.push({
                            event: "remove_from_cart",
                            ecommerce: {
                                items: [
                                    {
                                        item_name: this.cart[key].options.name.replace('<br>', ' '),
                                        item_id: this.cart[key].id,
                                        price: String(this.cart[key].options.price).replace(',', '.'),
                                        item_brand: 'Cantina Letrari',
                                        item_category: this.cart[key].options.type,
                                        item_variant: this.cart[key].options.combination.toLowerCase(),
                                        quantity: quantity_to_track
                                    }
                                ]
                            }
                        });

                    } else {

                        dataLayer.push({ ecommerce: null });
                        dataLayer.push({
                            event: "add_to_cart",
                            ecommerce: {
                                items: [
                                    {
                                        item_name: this.cart[key].options.name.replace('<br>', ' '),
                                        item_id: this.cart[key].id,
                                        price: String(this.cart[key].options.price).replace(',', '.'),
                                        item_brand: 'Cantina Letrari',
                                        item_category: this.cart[key].options.type,
                                        item_variant: this.cart[key].options.combination.toLowerCase(),
                                        quantity: quantity_to_track
                                    }
                                ]
                            }
                        });

                    }

                })
            },
            getCart() {
                axios.get('/api/cart/get')
                .then(response => {
                    //console.log(response);
                    this.cartRaw = response.data.cart;
                    this.count = response.data.count;
                    this.priceTotalWt = response.data.priceTotalWt;
                    this.finalPrice = response.data.finalPrice;
                    this.shipping = response.data.shipping;
                    this.missing_for_free_shipping = response.data.missingForFreeShipping;
                    this.discount = response.data.discount;
                    this.should_be_shipped = response.data.shouldBeShipped;

                    let products_gtm = []

                    try{

                        Object.keys(this.cartRaw).forEach(key => {
                            let entry = {};
                            entry.item_id = this.cartRaw[key].id;
                            entry.quantity = this.cartRaw[key].qty;
                            entry.item_brand = 'Cantina Letrari';
                            entry.item_name = this.cartRaw[key].options.name.replace('<br>', ' ');
                            entry.price = String(this.cartRaw[key].price).replace(',', '.');
                            entry.item_variant = this.cartRaw[key].options.combination.toLowerCase();
                            entry.item_category = this.cartRaw[key].options.type;
                            products_gtm.push(entry);
                        })

                        dataLayer.push({ ecommerce: null });
                        dataLayer.push({
                            event: "view_cart",
                            ecommerce: {
                                items: products_gtm
                            }
                        });

                    }catch(e) {
                        console.log(e)
                    }

                })

            },
            isNotEmpty(object) {
                return (_.isEmpty(object) === false);
            }
        },
        beforeDestroy() {
            this.$eventHub.$off('cart.added');
            this.$eventHub.$off('cart.show');
        },
        computed: {
            cart() {
                if(this.cartRaw == null) {
                    return null;
                }

                let tmp = {};
                for (const [key, value] of Object.entries(this.cartRaw)) {
                    if(typeof value.options.isDiscount == 'undefined' || value.options.isDiscount == false) {
                        tmp[key] = value;
                    }
                }

                return tmp;
            },
            itemCount() {
                if(typeof this.cart == 'undefined' || this.cart == null) {
                    return 0;
                } else {
                    return Object.keys(this.cart).length < 10 ? '' + Object.keys(this.cart).length : Object.keys(this.cart).length;
                }
            },
        }
    }

</script>
